// extracted by css-extract-rspack-plugin
export default {"grid":"_d5de4710"};